<template>
  <div class="media-record">

    <a-modal 
      :title="`媒体同步记录`"
      centered
      :width="'70%'"
      :mask-closable="false"
      :visible="showMediaRecordPage"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="handleCancel"
    >

        <div style="min-height:600px;margin:10px">
              <div class="search-wrapper" ref="search">
                  <a-space>
                      <a-input placeholder="广告主ID" v-model="queryParam.advertisre_id"/>
                      <a-input placeholder="广告主名称" v-model="queryParam.advertisre_name"/>
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button @click="resetSearch">重置</a-button>
                  </a-space>

                  <span style="margin-left:40px">
                      <b>刷新倒计时： <span style="color:red">{{ refreshTime}}</span> 秒</b>
                  </span>

              </div>

              <a-space style="margin-left:36px;margin-bottom:20px;">
                <a-button icon="plus" @click="uploadToMedia" v-if="accessTo('uploadToMedia')">同步巨量视频</a-button>
                <a-button icon="plus" @click="uploadToMedia(1, 1)" v-if="accessTo('uploadToMedia')">同步快手视频</a-button>
                <a-button icon="cloud-upload" @click="uploadToMedia(4, 1)" v-if="accessTo('uploadToMedia')">同步快手视频(本地上传)</a-button>
                <a-button icon="cloud"  @click="uploadToMedia(2)" v-if="accessTo('uploadToMedia')">推送视频</a-button>
              </a-space>


              <a-table
                  :scroll="{ x: 500, y:430}"
                  :columns="columns"
                  :row-key="record => record.id"
                  :data-source="data"
                  :pagination="pagination"
                  :loading="loading"
                  :transform-cell-text="$helper.emptyFormat"
                  @change="handleTableChange"
              >

              <div slot="status" slot-scope="record">
                <a-tag :color="record.status == 2 ? 'green' : 'red'">
                  {{ record.status == 2  ? '正常' : record.status == 3 ? '重试中': record.status == 4 ? '失败':'上传中' }}
                </a-tag>
                <a href="javascript:;" v-if="(record.status == 1 && record.retry_num>=4 && record.retry_num<=10) || record.status == 4" @click="clickRetry(record)">重试</a>
              </div>


              <div slot="action" slot-scope="record" class="actions">
                <a href="javascript:;" @click="choiceAdvertiser(record)">选择</a>  
              </div>

              </a-table>
        </div>

        <create-form v-if="showUploadForm" :showUploadForm.sync="showUploadForm" :model="model" @success="getList" />
    </a-modal>
    
  </div>
</template>

<style lang="less" scoped>
@import 'MediaRecord';
</style>

<script>
import MediaRecord from './MediaRecord'
export default MediaRecord
</script>

